export default __webpack_public_path__ + "static/media/img2.fee83b16.png";